"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyMLDSA87Signature = exports.qrlWalletType = exports.qrlSeedFromBytes = exports.newQrlExtendedSeed = exports.newMLDSA87Descriptor = exports.descriptorFromBytes = exports.newMLDSA87WalletFromExtendedSeed = exports.addressFromPublicKeyAndDescriptor = void 0;
const wallet_js_1 = require("@theqrl/wallet.js");
const Descriptor = wallet_js_1.Descriptor;
const ExtendedSeed = wallet_js_1.ExtendedSeed;
const MLDSA87 = wallet_js_1.MLDSA87;
const Seed = wallet_js_1.Seed;
const WalletType = wallet_js_1.WalletType;
const typedCreateWalletFromExtendedSeed = wallet_js_1.newWalletFromExtendedSeed;
const typedCreateMLDSA87Descriptor = wallet_js_1.newMLDSA87Descriptor;
const typedCreateAddressFromPublicKeyAndDescriptor = wallet_js_1.getAddressFromPKAndDescriptor;
const addressFromPublicKeyAndDescriptor = (publicKey, descriptor) => typedCreateAddressFromPublicKeyAndDescriptor(publicKey, descriptor);
exports.addressFromPublicKeyAndDescriptor = addressFromPublicKeyAndDescriptor;
const newMLDSA87WalletFromExtendedSeed = (extendedSeed) => typedCreateWalletFromExtendedSeed(extendedSeed);
exports.newMLDSA87WalletFromExtendedSeed = newMLDSA87WalletFromExtendedSeed;
const descriptorFromBytes = (bytes) => Descriptor.from(bytes);
exports.descriptorFromBytes = descriptorFromBytes;
const newMLDSA87Descriptor = () => typedCreateMLDSA87Descriptor();
exports.newMLDSA87Descriptor = newMLDSA87Descriptor;
const newQrlExtendedSeed = (descriptor, seed) => ExtendedSeed.newExtendedSeed(descriptor, seed);
exports.newQrlExtendedSeed = newQrlExtendedSeed;
const qrlSeedFromBytes = (bytes) => Seed.from(bytes);
exports.qrlSeedFromBytes = qrlSeedFromBytes;
exports.qrlWalletType = {
    ML_DSA_87: WalletType.ML_DSA_87,
};
const verifyMLDSA87Signature = (signature, message, publicKey) => MLDSA87.verify(signature, message, publicKey);
exports.verifyMLDSA87Signature = verifyMLDSA87Signature;
//# sourceMappingURL=qrl_wallet.js.map